<template>

<footer id="main-footer">
<p> Copyright 2021@ Magdalena Bygg och Måleri.se</p>
</footer>

</template>

<script>
export default {

}
</script>

<style>
#main-footer{background:royalblue;
    color:#fff;
    text-align: center;
    padding: 20px;
    margin-top: 40}


</style>